// extracted by mini-css-extract-plugin
export default {"dropdownRenderer":"style_dropdown-renderer__Qqp9y"};